import React, { Fragment } from 'react';

const LEFT_PAGE = 'LEFT';
const RIGHT_PAGE = 'RIGHT';

/**
 * Helper method for creating a range of numbers
 * range(1, 5) => [1, 2, 3, 4, 5]
 */

const range = (from, to, step = 1) => {
	let i = from;
	const range = [];

	while (i <= to) {
		range.push(i);
		i += step;
	}

	return range;
};

export default class Pagination extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('Pagination', this.props);

		const totalPages = Math.ceil(
			this.props.totalRecords / this.props.pageLength
		);

		if (!this.props.totalRecords) return null;
		// if (totalPages === 1) return null; // Uncomment if you want to hide the Pagination component when totals records returned fit on one page or less

		const { currentPage } = this.props;
		const pages = this.fetchPageNumbers();

		return (
			<Fragment>
				<div className="Pagination" aria-label="Users Pagination">
					<ul className="pagination">
						{pages.map((page, index) => {
							if (page === LEFT_PAGE)
								return (
									<li key={index} className="page-item">
										<a
											className="page-link"
											href="#"
											aria-label="Previous"
											onClick={this.handleMoveLeft}
										>
											<span aria-hidden="true">&laquo;</span>
											<span className="sr-only">Previous</span>
										</a>
									</li>
								);

							if (page === RIGHT_PAGE)
								return (
									<li key={index} className="page-item">
										<a
											className="page-link"
											href="#"
											aria-label="Next"
											onClick={this.handleMoveRight}
										>
											<span aria-hidden="true">&raquo;</span>
											<span className="sr-only">Next</span>
										</a>
									</li>
								);

							return (
								<li
									key={index}
									className={`page-item${currentPage === page
										? ' active'
										: ''}`}
								>
									<a
										className="page-link"
										href="#"
										onClick={this.handleClick(page)}
									>
										{page}
									</a>
								</li>
							);
						})}
					</ul>
				</div>
			</Fragment>
		);
	}

	componentDidMount() {
		this.gotoPage(1);
	}

	gotoPage = (page) => {
		const { onPageChanged = (f) => f } = this.props;
		const paginationData = {
			currcurrentPage: this.props.currentPageentPage,
			totalPages: this.totalPages,
			pageLimit: this.pageLimit,
			totalRecords: this.totalRecords
		};

		this.props.onChangeCurrentPage(page, () => onPageChanged(paginationData));
	};

	handleClick = (page) => (evt) => {
		evt.preventDefault();
		this.gotoPage(page);
	};

	handleMoveLeft = (evt) => {
		evt.preventDefault();
		this.gotoPage(this.props.currentPage - this.props.pageNeighbours * 2 - 1);
	};

	handleMoveRight = (evt) => {
		evt.preventDefault();
		this.gotoPage(this.props.currentPage + this.props.pageNeighbours * 2 + 1);
	};

	fetchPageNumbers = () => {
		const totalPages = Math.ceil(
			this.props.totalRecords / this.props.pageLength
		);
		const currentPage = this.props.currentPage;
		const pageNeighbours = this.props.pageNeighbours;

		/**
     * totalNumbers: the total page numbers to show on the control
     * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
     */
		const totalNumbers = this.props.pageNeighbours * 2 + 3;
		const totalBlocks = totalNumbers + 2;

		if (totalPages > totalBlocks) {
			const startPage = Math.max(2, currentPage - pageNeighbours);
			const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
			let pages = range(startPage, endPage);

			/**
       * hasLeftSpill: has hidden pages to the left
       * hasRightSpill: has hidden pages to the right
       * spillOffset: number of hidden pages either to the left or to the right
       */
			const hasLeftSpill = startPage > 2;
			const hasRightSpill = totalPages - endPage > 1;
			const spillOffset = totalNumbers - (pages.length + 1);

			switch (true) {
				// handle: (1) < {5 6} [7] {8 9} (10)
				case hasLeftSpill && !hasRightSpill: {
					const extraPages = range(startPage - spillOffset, startPage - 1);
					pages = [
						LEFT_PAGE,
						...extraPages,
						...pages
					];
					break;
				}

				// handle: (1) {2 3} [4] {5 6} > (10)
				case !hasLeftSpill && hasRightSpill: {
					const extraPages = range(endPage + 1, endPage + spillOffset);
					pages = [
						...pages,
						...extraPages,
						RIGHT_PAGE
					];
					break;
				}

				// handle: (1) < {4 5} [6] {7 8} > (10)
				case hasLeftSpill && hasRightSpill:
				default: {
					pages = [
						LEFT_PAGE,
						...pages,
						RIGHT_PAGE
					];
					break;
				}
			}

			return [
				1,
				...pages,
				totalPages
			];
		}

		return range(1, totalPages);
	};
}
